import React from 'react';

// Small segmented control shared by every view that can be shown more than one
// way. Options are [value, label] pairs.

export default function ViewToggle({ options, value, onChange, ariaLabel }) {
    return (
        <div className="vtoggle" role="group" aria-label={ariaLabel}>
            {options.map(([key, label]) => (
                <button
                    key={key}
                    type="button"
                    className={`vtoggle__btn${value === key ? ' is-active' : ''}`}
                    aria-pressed={value === key}
                    onClick={() => onChange(key)}
                >
                    {label}
                </button>
            ))}
        </div>
    );
}
